import axios, { AxiosRequestConfig } from "axios";
import constants from "$utils/constants";

export const get = async <R>(
  url: string,
  config?: AxiosRequestConfig
): Promise<R> => {
  const { data } = await axios.get<R>(url, config);
  return data;
};

export const remove = async <R>(
  url: string,
  config?: AxiosRequestConfig
): Promise<R> => {
  const { data } = await axios.delete<R>(url, config);
  return data;
};

export const post = async <R>(
  url: string,
  body?: any,
  config?: AxiosRequestConfig
): Promise<R> => {
  const { data } = await axios.post<R>(url, body, config);
  return data;
};

export const put = async <R>(
  url: string,
  body?: any,
  config?: AxiosRequestConfig
): Promise<R> => {
  const { data } = await axios.put<R>(url, body, config);
  return data;
};

export const checkAPI = async () => {
  const endPoint = constants.API.ENDPOINTS.CHECK;
  let data = null;
  try {
    await get(endPoint).then((e) => {
      data = e;
    });
  } catch (e: any) {
    data = { message: `error ${e?.message || ""}` };
  }
  return data;
};

export const checkProtectedApi = async (
  token: string,
  endPoint: string = constants.API.ENDPOINTS.PRIVATE
) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  let data = null;
  try {
    await get(endPoint, config).then((e: any) => {
      data = e;
    });
  } catch (e: any) {
    data = { message: `error ${(e as any).message}` };
  }
  return data;
};
